import React, { lazy, Suspense } from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Spin } from 'antd'

// Base Layout & Pages
const GeekLayout = lazy(() => import('@/pages/Layout/index.js'))
const Login = lazy(() => import('@/pages/Login/index.js'))

// Campaign Submodules
const CanvassEntry = lazy(() => import('@/pages/Campaign/CanvassEntry.js'))
const MyCanvassRecords = lazy(() => import('@/pages/Campaign/MyCanvassRecords.js')) // 💡 新增：Soldier 个人记录页面
const PhoneCanvass = lazy(() => import('@/pages/Campaign/PhoneCanvass.jsx')) // 💡 新增：独立外呼页面
const GisMapAnalytics = lazy(() => import('@/pages/Campaign/GisMapAnalytics.js'))
const TurfAssign = lazy(() => import('@/pages/Campaign/TurfAssign.js'))
const LawnSignManagement = lazy(() => import('@/pages/Campaign/LawnSignManagement.js'))
const CanvasserPerformance = lazy(() => import('@/pages/Campaign/CanvasserPerformance.js'))
const DemographicReports = lazy(() => import('@/pages/Campaign/DemographicReports.js'))
const CanvassingTrends = lazy(() => import('@/pages/Campaign/CanvassingTrends.js'))
const UserHierarchy = lazy(() => import('@/pages/Campaign/UserHierarchy.js'))
const NotFound = lazy(() => import('@/pages/NotFound/index.js'))

// Auth Guard
const AuthRoute = ({ children }) => {
  const token = localStorage.getItem('token_key')
  return token ? children : <Navigate to="/login" replace />
}

// Suspense Loader Wrapper
const withSuspense = (Component) => (
  <Suspense
    fallback={
      <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 120 }}>
        <Spin size="large" tip="Loading Campaign Module..." />
      </div>
    }
  >
    {Component}
  </Suspense>
)

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthRoute>
        {withSuspense(<GeekLayout />)}
      </AuthRoute>
    ),
    children: [
      {
        index: true,
        element: withSuspense(<CanvassEntry />)
      },
      {
        path: 'canvass-entry',
        element: withSuspense(<CanvassEntry />)
      },
      {
        path: 'my-records', // 💡 新增：注册 /my-records 路由
        element: withSuspense(<MyCanvassRecords />)
      },
      { path: 'phone-canvass', 
        element: <PhoneCanvass /> },
      {
        path: 'gis-map',
        element: withSuspense(<GisMapAnalytics />)
      },
      {
        path: 'turf-assign',
        element: withSuspense(<TurfAssign />)
      },
      {
        path: 'lawn-signs',
        element: withSuspense(<LawnSignManagement />)
      },
      {
        path: 'canvassers',
        element: withSuspense(<CanvasserPerformance />)
      },
      {
        path: 'reports/demographics',
        element: withSuspense(<DemographicReports />)
      },
      {
        path: 'reports/trends',
        element: withSuspense(<CanvassingTrends />)
      },
      {
        path: 'users',
        element: withSuspense(<UserHierarchy />)
      }
    ]
  },
  {
    path: '/login',
    element: withSuspense(<Login />)
  },
  {
    path: '*',
    element: withSuspense(<NotFound />)
  }
])

export default router